import { ReactNode } from 'react'

interface PopupFooterProps {
	children: ReactNode
	className?: string
}

const PopupFooter: React.FC<PopupFooterProps> = ({ children, className = '' }) => {
	return (
		<div
			className={`flex shrink-0 flex-wrap justify-end items-center gap-2 border-t border-[hsl(var(--border))] bg-[hsl(var(--muted)/0.35)] px-4 py-3 sm:px-5 ${className}`.trim()}
		>
			{children}
		</div>
	)
}

export default PopupFooter
